/* eslint-disable react-hooks/exhaustive-deps  */
/* eslint-disable array-callback-return  */
import React, {
  Fragment,
  useState,
  useCallback,
  useEffect,
  useRef,
  useMemo
} from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { generatePath } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useForm, useField } from "react-final-form-hooks";
import { Svg } from "app/components";
import storage from "app/services/session";
import useEffectFormReset from "app/hooks/useEffectFormReset";
import { getPreValidationError } from "app/utils";
import useConfig from "app/hooks/useConfig";
import useModal from "app/hooks/useModal";
import usePayment from "app/hooks/usePayment";
import {
  Ticket,
  withTicket,
  SelectionTotal,
  withSelection
} from "app/modules/order";
import {
  Button,
  LineBordered,
  TitleAccent,
  Checkbox,
  Label,
  Modal,
  Switch,
  Input
} from "app/components";

import useFromPaymentEffect from "../hooks/useFromPaymentEffect";
import EmailConfirmation from "../EmailConfirmation";
import { List } from "../../account/GiftCard/styles";
import { RowButton, StepWrapper, Info } from "../styles";
import {
  CheckboxRow,
  GiftCardSection,
  BonusCardAttention,
  IconButton,
  IconButtonPlus,
} from "./styles";
import { useLocation } from "react-router-dom/cjs/react-router-dom";

// const SelectionTotalWrapper = withSelection('booking')(SelectionTotal); //reserved

const propTypes = {
  reserve: PropTypes.func.isRequired,
  buy: PropTypes.func.isRequired,
  description: PropTypes.func,
  isLoggedIn: PropTypes.bool.isRequired,
  isReserved: PropTypes.bool.isRequired,
  isReservationEnded: PropTypes.bool.isRequired,

  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,

  userSessionId: PropTypes.string,
  order: PropTypes.shape({
    tickets: PropTypes.arrayOf(PropTypes.any).isRequired
  }),

  legalInfo: PropTypes.arrayOf(
    PropTypes.shape({
      doc: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired
    })
  ).isRequired,
  userGiftcards: PropTypes.arrayOf(PropTypes.object),
  getGiftcards: PropTypes.func.isRequired,
  getRestrictions: PropTypes.func.isRequired,
  addGiftcard: PropTypes.func.isRequired,
  isBonus: PropTypes.bool.isRequired,
  buywithBonus: PropTypes.func.isRequired,
  applyGiftcard: PropTypes.func.isRequired,
  buyWithGift: PropTypes.func.isRequired,
  child: PropTypes.number,
  adult: PropTypes.number,
  reduced: PropTypes.number,
  packageRegular: PropTypes.number,
  packageChild: PropTypes.number,
  packageReduced: PropTypes.number,
  packageClub: PropTypes.number,
  isGiftCardApplied: PropTypes.bool,
  saveWizard: PropTypes.func.isRequired,
  validateWithSchema: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  userRestrictions: PropTypes.object.isRequired,
  reservedBooking: PropTypes.object.isRequired,
  reservedGiftResult: PropTypes.object.isRequired,
  paymentGiftcardData: PropTypes.object.isRequired,
  bonusCardSimplePayment: PropTypes.object.isRequired,
  loader: PropTypes.bool,
  reservedPayment: PropTypes.func.isRequired,
  reservedGiftcardPayment: PropTypes.func.isRequired,
  booking: PropTypes.shape({
    bookingId: PropTypes.string.isRequired,
    isPaid: PropTypes.bool.isRequired
  }),
  location: PropTypes.shape({
    state: PropTypes.object.isRequired,
  }).isRequired,
  fetchBooking: PropTypes.func.isRequired,
  giftCardpayment: PropTypes.bool.isRequired,
  addLogoutGiftcard: PropTypes.func.isRequired,
  dataSetAgain: PropTypes.func.isRequired,
  clearGiftcardSession: PropTypes.func.isRequired,
  newGiftcardAdd: PropTypes.bool.isRequired,
  newGiftcard: PropTypes.arrayOf(PropTypes.object)
};

const defaultProps = {
  order: null,
  userSessionId: null,
  child: 0,
  adult: 0,
  reduced: 0,
  packageRegular: 0,
  packageChild: 0,
  packageReduced: 0,
  packageClub: 0,
  isGiftCardApplied: true,
  userGiftcards: null,
  loader: false,
  paymentGiftcardData: null,
  reservedGiftResult: null,
  bonusCardSimplePayment: null
};
const StepCheckout = ({
  reserve,
  buy,
  description,
  isLoggedIn,
  userSessionId,
  isReserved,
  history: { push },
  order,
  isReservationEnded,
  legalInfo,
  userGiftcards,
  getGiftcards,
  addGiftcard,
  child,
  adult,
  reduced,
  packageRegular,
  packageChild,
  packageReduced,
  packageClub,
  isBonus,
  buywithBonus,
  applyGiftcard,
  buyWithGift,
  isGiftCardApplied,
  saveWizard,
  validateWithSchema,
  userRestrictions,
  loader,
  reservedPayment,
  reservedGiftcardPayment,
  booking,
  location: { state },
  reservedBooking,
  reservedGiftResult,
  paymentGiftcardData,
  giftCardpayment,
  fetchBooking,
  // fetch,
  bonusCardSimplePayment,
  addLogoutGiftcard,
  clearGiftcardSession,
  dataSetAgain,
  newGiftcardAdd,
  newGiftcard,
  getRestrictions
}) => {
  const [t, i18n] = useTranslation();
  const lang = i18n.language === 'en-US' ? 'en' : i18n.language === 'de-DE' ? 'de' : i18n.language === 'de' ? 'de' : i18n.language === 'en' && 'en';

  const {
    routes,
    media: { docsPrefix },
    wizard: {
      stepCheckout: { messages }
    },
    currencyForCountry,
    showingOptions
  } = useConfig();
  const giftcardRef = useRef(true);
  const userData = useSelector(state => state.user.user);
  const orderData = useSelector(state => state.order);
  const descriptionData = useSelector(state => state.payment.description[0]);
  const prevRoute = state?.prevRoute;
  const reservedUserSessionId = state?.userSessionId;
  const bookingNumber = state?.bookingNumber;
  // const bookingIdD = state?.bookingId;
  // const cinemaId = state?.cinemaId;
  const orderProps = state?.order;
  // const bookingData = state?.bookingData;

  const { payment, status } = useSelector(state => state.payment);
  // const { session } = useSelector(state => state.sessions);
  const appliedGiftcard = useSelector(state => state.payment.appliedGiftcard);

  const [isPDProcessing, setPDProcessing] = useState(false);
  // const [focusOff, setFocusOff] = useState(false);
  const [isTac, setTac] = useState(false);
  const [isCookie, setCookie] = useState(false);
  const [giftcards, setGiftcards] = useState([]);
  const [validationError, setValidationError] = useState("");
  const [giftcardLoaded, setGiftcardLoaded] = useState(false);
  const [isPayble, setIsPayble] = useState(false);
  const [isCheckGiftcards, setIsCheckGiftcards] = useState(false);
  const [payloadForDirect, setPayloadForDirect] = useState([]);
  const [isBuyDone, setIsBuyDone] = useState(false);
  let userId = userSessionId ? userSessionId : reservedUserSessionId;
  const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));
  const [isModalError, showModalError, hideModalError] = useModal("error");
  const [validGiftCardNumber, setValidGiftCardNumber] = useState(true);

  // const { pathname } = useLocation();
  const location = useLocation();
  const movieCinemaId = sessionStorage.getItem("movieCinemaId");

  // if mail is comming from season-pass
  const email = state;
  if (!movieCinemaId) {
    sessionStorage.setItem("movieCinemaId", location?.pathname.split('/')[3])
  }
  const send = async (values, { reset }, notifyErrors) => {

    if (giftcards.some((x) => x.number === values?.giftCard)) {
      return showModalError();
    } else {
      if (!isLoggedIn) {
        addLogoutGiftcard(values?.giftCard, notifyErrors)
      } else {
        if (userGiftcards.some((x) => x.number === values?.giftCard)) {
          userGiftcards.filter((x) => {
            if (x.number === values?.giftCard) {
              let array = [];
              let payloadValue = x;
              if (giftcards !== null) {
                array.push(...giftcards, payloadValue)
              } else {
                array.push(payloadValue)
              }
              setGiftcards(array)
            }
          })
        } else {
          // addGiftcard(values?.giftCard, notifyErrors, t, userRestrictions);
          if (values?.giftCard && validGiftCardNumber === true) {
            addGiftcard(values?.giftCard, notifyErrors, t, userRestrictions);
            setValidGiftCardNumber(false);
          } else {
            setValidGiftCardNumber(false);
            const { isAllowGiftCardNumber } = userRestrictions[0];
            if (isAllowGiftCardNumber && values?.giftCard.length > 16) {
              showErrorConfirm();
            }
            else if (values?.giftCard.length === 16) {
              showErrorConfirm();
            }
          }
        }
      }
      setIsCheckGiftcards(true)
      await sleep(1000);
      reset();
    }
  }

  const {
    form,
    handleSubmit,
    submitErrors: errors,
    submitSucceeded,
    submitting
  } = useForm({
    onSubmit: send,
    validate: validateWithSchema
  });

  const giftCard = useField("giftCard", form);
  const [disabled, setDisabled] = useState(false);

  const [isModal, showModal, hideModal] = useModal("emailConfirmation");
  const [isAttentionModal, showAttentionModal, hideAttentionModal] = useModal(
    "attention"
  );
  const [errorConfirm, showErrorConfirm, hideErrorConfirm] = useModal(
    "errorConfirm"
  );
  const isBtnDisabled = !(isTac && isCookie && isPDProcessing);

  const usageConditions = {
    processingOfPersonalData: {
      element: (
        <Checkbox
          id="personal-data-processing"
          value={isPDProcessing}
          checked={isPDProcessing}
          onChange={e => setPDProcessing(e.currentTarget.value === "false")}
        />
      ),
      word: "personal_data_processing"
    },

    termsAndConditions: {
      element: (
        <Checkbox
          id="tac"
          value={isTac}
          checked={isTac}
          onChange={e => setTac(e.currentTarget.value === "false")}
        />
      ),
      word: "tac"
    },

    cookiePolicy: {
      element: (
        <Checkbox
          id="cookie-policy"
          value={isCookie}
          checked={isCookie}
          onChange={e => setCookie(e.currentTarget.value === "false")}
        />
      ),
      word: "cookie_policy"
    }
  };

  usePayment(order);
  useFromPaymentEffect();

  useEffect(() => {
    if (isLoggedIn === true && isCheckGiftcards === false) {
      setGiftcards(userGiftcards);
    }
    if (isLoggedIn === true && newGiftcardAdd === true && Object.keys(newGiftcard).length > 0) {
      let array = [];
      let payloadValue = newGiftcard;
      if (giftcards !== null) {
        array.push(...giftcards, payloadValue)
      } else {
        array.push(payloadValue)
      }
      setGiftcards(array)
    }
  }, [userGiftcards, isLoggedIn])

  useEffect(() => {
    const numberLength = giftCard?.input?.value?.length;
    let msg = "";
    if (numberLength > 16) {
      msg = t("common.giftcard_digit_error");
      setValidationError(msg);
      setValidGiftCardNumber(false);
    }
    else if (numberLength >= 16 && userRestrictions[0] !== undefined) {
      const { allowedGiftCardNumber } = userRestrictions[0];

      const allowedRange = allowedGiftCardNumber?.split(";");
      if (!allowedRange?.some(item =>
        giftCard?.input?.value?.startsWith(item?.replace("*", ""))
      )
      ) {
        msg = t("common.giftcard_invalid");
        setValidationError(msg);
        setValidGiftCardNumber(false);
      }
      else {
        setValidGiftCardNumber(true);
      }
    }
  }, [giftCard]);

  useEffect(() => {
    if (loader) giftcardRef.current = true;
    if (!loader && giftcardRef.current) setGiftcardLoaded(true);
  }, [loader]);

  const setApplyBonuscard = useCallback(
    val => {
      const totalBalanceData = giftcards?.reduce(
        (total, cur) =>
          total + parseFloat(cur?.formattedValue?.replace(",", "."), 10),
        0
      );
      let totalPrice = orderData ? orderData?.orderTotalValueInCents : orderProps?.totalPrice;
      let totalPrice_ = totalPrice / 100;
      if (val === false) {
        setDisabled(false)
      } else {
        if (giftcards?.length > 0) {
          if (totalBalanceData !== 0) {
            if (totalBalanceData >= totalPrice_) {
              setDisabled(false)
            } else {
              // setDisabled(true)
            }
          } else {
            // setDisabled(true)
          }
        }
      }
      storage.setIsAppliedBonusGiftCard(val)
      return saveWizard({ isGiftCardApplied: val, child, adult, reduced, isBonus, packageRegular, packageChild, packageReduced, packageClub });
    },
    [saveWizard, isGiftCardApplied, child, adult, reduced, packageRegular, packageChild, packageReduced, packageClub, isBonus]
  );

  useEffect(() => {
    if (isLoggedIn) {
      // if (!isBonus && !userGiftcards && isGiftCardApplied === 'true' && isLoggedIn) {
      //   getGiftcards();
      // }
      if (appliedGiftcard !== null) {
        if (userGiftcards?.length > 0 && isLoggedIn) setApplyBonuscard(true);
      }
    } else {
      setGiftcardLoaded(true);
      if (userGiftcards?.length > 0) {
        const key = 'number';
        if (userGiftcards?.length > 0) {
          const unique = [...new Map(userGiftcards?.map(item =>
            [item[key], item])).values()];
          setGiftcards(unique);
          setApplyBonuscard(true)
        }
      } else if (userGiftcards?.length < 1) {
        setApplyBonuscard(false)
      }
    }
  }, [isLoggedIn, userGiftcards]);

  useEffect(() => {
    if (isReserved) {
      push(generatePath(routes.reservationSuccess.pattern, { userSessionId: userId }));
    }
    // eslint-disable-next-line
  }, [isReserved]);

  const legalInfoSetterMap = {
    termsAndConditions: setTac,
    cookiePolicy: setCookie,
    processingOfPersonalData: setPDProcessing
  };

  /**
   * Set true if there is no such document
   */
  useEffect(() => {
    Object.keys(legalInfoSetterMap).forEach(setterKey => {
      const noDocumentFound = !legalInfo.find(info => info.type === setterKey);

      if (noDocumentFound) {
        const setter = legalInfoSetterMap[setterKey];

        setter(true);
      }
    });
  }, [legalInfo, legalInfoSetterMap]);

  useEffect(() => {
    if (errors?.message === "validationError") {
      const { allowedGiftCardNumber } = userRestrictions;
      const numberLength = giftCard?.input?.value?.length;

      const allowedRange = allowedGiftCardNumber.split(";");

      let msg = "";

      if (numberLength !== 16) {
        msg = t("common.giftcard_digit_error");
      } else if (
        numberLength === 16 &&
        !allowedRange.some(item =>
          giftCard?.input?.value?.startsWith(item.replace("*", ""))
        )
      ) {
        msg = t("common.giftcard_number_error", {
          what: allowedGiftCardNumber
        });
      }

      setValidationError(msg);
    } else if (errors?.message) {
      showErrorConfirm();
      setValidationError(errors?.message);
    }
  }, [errors?.message, t]);

  useEffect(() => {
    if (appliedGiftcard) {
      const email = sessionStorage.getItem("email");
      buy(userId, email);
    }
  }, [appliedGiftcard]);

  useEffect(() => {
    description()
  }, [])

  useEffectFormReset(form, errors, submitSucceeded, submitting);

  const onBuy = useCallback(() => {
    let totalBalance = 0
    let orderValueInCents = 0
    let totalPrice = orderData ? orderData?.orderTotalValueInCents : orderProps?.totalPrice / 100;
    let _totalPrice = totalPrice / 100;
    setIsBuyDone(true)
    if (giftcards?.length > 0) {
      totalBalance = giftcards.reduce(
        (total, cur) =>
          total + parseFloat(cur.formattedValue.replace(",", "."), 10),
        0
      );
      orderValueInCents = orderData?.orderTotalValueInCents / 100;
    }
    if (isBonus && userData?.giftCardBalance < orderValueInCents) {
      return showAttentionModal();
    }
    if (isLoggedIn) {
      if (isBonus) {
        storage.setIsAppliedBonusGiftCard(true);
        return buywithBonus(userId);
      }
      const payloadData = giftcards?.map(item => ({ 'Number': item?.number, 'ValueInCents': item?.valueInCents, 'FormattedValue': item?.formattedValue }))
      const payload = giftcards?.map(item => ({ Number: item?.number }));

      if (!isBonus && isGiftCardApplied) {

        let totalPrice = orderData ? orderValueInCents : orderProps?.totalPrice / 100;
        if (totalBalance >= totalPrice) {
          storage.setIsAppliedBonusGiftCard(true);
          if (prevRoute === "reserved" && isGiftCardApplied) {
            return reservedGiftcardPayment({ bookingNumber: bookingNumber, payload: payloadData });
          } else {
            // return buyWithGift(userId, payload);
          }
        } else {
          // storage.setIsAppliedBonusGiftCard(false);
          // saveWizard({ isGiftCardApplied: false, child, adult, reduced, isBonus }) // in future remove this line for payment both side (gift/payment getway)
          return applyGiftcard(userSessionId, payload);
          // return buy(userId);
        }
        // storage.setIsAppliedBonusGiftCard(false);
        // return applyGiftcard(userSessionId, payload);
      }
      storage.setIsAppliedBonusGiftCard(false);
      if (prevRoute === "reserved") {
        let totalPrice = orderData ? orderValueInCents : orderProps?.totalPrice / 100;
        if (isGiftCardApplied && totalBalance >= totalPrice) {
          return reservedGiftcardPayment({ bookingNumber: bookingNumber, payload: payloadData });
        } else {
          return reservedPayment({ bookingNumber: bookingNumber, type: "payment" });
        }
      } else {
        if (email?.isAboId) {
          return buy(userSessionId);
        }
        else if (!isBonus && isGiftCardApplied) {
          return buyWithGift(userId, payload);
        }
        else if (email?.email) {
          return buy(userSessionId, email?.email);
        }
        else {
          return buy(userSessionId);
        }

      }
    } else {
      const payloadData = giftcards?.map(item => ({ 'Number': item?.number, 'ValueInCents': item?.valueInCents, 'FormattedValue': item?.formattedValue }))
      setPayloadForDirect(payloadData)
      setIsPayble(totalBalance >= _totalPrice)
      return showModal();
    }


  }, [
    userId,
    isLoggedIn,
    buy,
    buyWithGift,
    buywithBonus,
    showModal,
    isBonus,
    isGiftCardApplied,
    giftcards
  ])

  const onReserve = useCallback(() => {
    reserve(userId);
  }, [userId, reserve, isGiftCardApplied, isBonus]);

  const handleRemoveGiftcard = index => {
    // const giftcardList = [...userGiftcards];
    const giftcardList = [...giftcards];
    giftcardList.splice(index, 1);
    if (giftcardList.length === 0) {
      setApplyBonuscard(false)
      clearGiftcardSession();
    }
    // dataSetAgain(giftcardList)
    setGiftcards(giftcardList);
  };

  useEffect(() => {
    let orderValue = orderData?.orderTotalValueInCents ? orderData?.orderTotalValueInCents : orderProps?.totalPrice / 100;
    if (orderValue > 0 && !isBonus) {
      if (giftcards?.length > 0 && userGiftcards?.length > 0) {
        setApplyBonuscard(true)
        const totalBalanceData = giftcards.reduce(
          (total, cur) =>
            total + parseFloat(cur.formattedValue.replace(",", "."), 10),
          0
        );
        if (totalBalanceData !== 0 && totalBalanceData >= orderValue) {
          setDisabled(false)
        }
        else {
          if (prevRoute === "reserved") {
            setDisabled(true)
          }

        }
      } else if (giftcards?.length < 1 && userGiftcards?.length < 1) {
        setApplyBonuscard(false)
      }
    }
  }, [orderData, giftcards, userGiftcards])

  useEffect(() => {
    if (status && status?.status == status?.codes?.ERROR && isLoggedIn) {
      getGiftcards();
      getRestrictions();
    }
  }, [status])

  useEffect(() => {
    if (!payment && !status) {
      return undefined;
    }
    if (payment && Object?.keys(payment)?.length > 0 && isBuyDone === true && (isBonus)) {
      push(generatePath(routes.paymentSuccess.pattern, { userSessionId: userId }));
    } else if (!payment && isBuyDone && status.status === status.codes.FAIL) {
      push(generatePath(routes.paymentFailure.pattern, { id: userId }));
    }
  }, [payment, status, isBuyDone]);

  useEffect(() => {
    if (isBuyDone === true && Object?.keys(reservedGiftResult)?.length > 0) {
      push(generatePath(routes.paymentSuccess.pattern, { userSessionId: userId }));
    } else if (isBuyDone === true && Object?.keys(bonusCardSimplePayment)?.length > 0) {
      push(generatePath(routes.paymentSuccess.pattern, { userSessionId: userId }));
    } else if (isBuyDone === true && Object?.keys(paymentGiftcardData)?.length > 0) {
      push(generatePath(routes.paymentSuccess.pattern, { userSessionId: userId }));
    }
  }, [reservedGiftResult, isBuyDone, bonusCardSimplePayment, paymentGiftcardData])

  useEffect(() => {
    if (!email?.isAboId && !isBonus && !userGiftcards && isLoggedIn) {
      getGiftcards();
      getRestrictions();
    }
  }, [])

  useEffect(() => {
    if (!isLoggedIn) {
      setGiftcards([])
    }
  }, [isLoggedIn])

  useEffect(() => {
    if (giftcards?.length <= 0 && userGiftcards === null) {
      setApplyBonuscard(false)
    }
  }, [giftcards, userGiftcards])


  const languageContents = useMemo(
    () => ({
      description: i18n.language === 'en' || i18n.language === 'en-US' ? 'hintcheckoutpurchaseEN' : 'hintcheckoutpurchase',
    }),
    [i18n.language]
  );

  const TicketWrapped = withTicket("session")(Ticket);
  const SelectionTotalWrapper = withSelection("session")(SelectionTotal, orderProps);

  const renderLink = (data) => {
    if (data === "cookie_policy") {
      return legalInfo[3]?.doc
    }
    else if (data === "tac") {
      return legalInfo[1]?.doc
    }
    else {
      return legalInfo[4]?.doc
    }
  }


  const LayoutRender = () => {
    return (
      <>
        {
          !isBonus && showingOptions.giftcards && !location?.state?.isAboId &&
          <GiftCardSection>
            <div className="checkout-giftcard__header">
              <h3>{t("common.use_gift_card")}</h3>
              <Switch checked={isGiftCardApplied} onChange={e => setApplyBonuscard(e.target.checked)} />
            </div>

            {isGiftCardApplied && (
              <>
                {giftcards?.length > 0 && (
                  <div>
                    <h3 className="checkout-giftcard__giftcards_title">
                      {t("purchase.add_remove_giftcard")}
                    </h3>
                    {giftcards?.map((item, index) => (
                      <div
                        key={item?.number}
                        className="checkout-giftcard__giftcard_item"
                      >
                        <div className="checkout-giftcard__barcode_number">
                          <h3>{item?.number}</h3>
                        </div>
                        <div className="checkout-giftcard__price">
                          <h3>{currencyForCountry} {item?.formattedValue}</h3>
                          <IconButton
                            isPrimary
                            className="minus-btn"
                            onClick={() => handleRemoveGiftcard(index)}>
                            <Svg id="minus" />
                          </IconButton>
                          <Button
                            className="checkout-giftcard__price_remove_btn"
                            isPrimary
                            onClick={() => handleRemoveGiftcard(index)}
                          >
                            {t('purchase.remove_giftcard')}
                          </Button>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
                <form
                  className="checkout-giftcard__add_new"
                  onSubmit={handleSubmit}
                >
                  <div className="checkout-giftcard__add_new_input">
                    <Label htmlFor="giftCard">
                      {t("purchase.enter_giftcard_input")}
                    </Label>
                    <Input
                      id="giftCard"
                      type="text"
                      pattern="\d*"
                      inputMode="numeric"
                      // disabled={!userRestrictions[0]?.isAllowGiftCardNumber}
                      {...giftCard.input}
                      error={getPreValidationError(giftCard, t)}
                    />
                  </div>
                  <IconButtonPlus type="submit"
                    className="plus-btn"
                    isPrimary>
                    <Svg id="plus" />
                  </IconButtonPlus>
                  <Button type="submit" className="checkout-giftcard__add_new_btn " isPrimary>
                    {t('common.add_new_giftcard')}
                  </Button>

                </form>
              </>
            )}
          </GiftCardSection>
        }
        <SelectionTotalWrapper order={orderProps} />
        {
          !isLoggedIn && legalInfo.length ? (
            <Fragment>
              <LineBordered>
                <TitleAccent>{t("registration.agree_with")}</TitleAccent>
              </LineBordered>
              {legalInfo?.map(info => {
                const infoItem = usageConditions[info?.type];
                // let {element,  word } = infoItem;
                return (
                  infoItem?.element && infoItem?.word ?
                    <CheckboxRow key={info.doc}>
                      <Label>
                        {infoItem?.element}
                        <span className="text">{t(`common.${infoItem?.word}`)}.</span>
                        <a
                          className="link text"
                          href={process.env.REACT_APP_COUNTRY === "mne" ? docsPrefix(renderLink(infoItem?.word)) : docsPrefix(info.doc)}
                          rel="noopener noreferrer"
                          target="_blank"
                        >
                          {t("common.read_more")}
                        </a>
                      </Label>
                    </CheckboxRow>
                    : ''
                );
              })}
            </Fragment>
          ) : null
        }
        {
          messages
            ? messages[lang]?.map(message => (
              <Info key={message}>{message}</Info>
            ))
            : null
        }
        {
          disabled === true &&
          <span className="giftcard_note">{t('purchase.not_enoght_credit')}</span>
        }
        <RowButton>
          {isLoggedIn && !isReservationEnded && !location?.state?.isAboId && prevRoute !== "reserved" ? (
            <Button isDefault onClick={onReserve}>
              {t("purchase.reserve")}
            </Button>
          ) : null}
          {/* {process.env.REACT_APP_COUNTRY !== "mne" &&
            <Button
              className={disabled === true ? `disabled` : ``}
              isPrimary
              onClick={onBuy}
              disabled={!isGiftCardApplied && (isBtnDisabled && !isLoggedIn)}
            >
              {t("purchase.buy")}
            </Button>
          } */}
          {process.env.REACT_APP_COUNTRY !== "mne" ?
            <Button
              className={disabled === true ? `disabled` : ``}
              isPrimary
              onClick={onBuy}
              disabled={isBtnDisabled && !isLoggedIn}
            >
              {t("purchase.buy")}
            </Button>
            : isBonus && <Button
              className={disabled === true ? `disabled` : ``}
              isPrimary
              onClick={onBuy}
              disabled={isBtnDisabled && !isLoggedIn}
            >
              {t("purchase.buy")}
            </Button>
          }
        </RowButton>
        <GiftCardSection>
          <div className="step-checkout__description">
            <span
              className=""
              dangerouslySetInnerHTML={{
                __html: descriptionData?.[languageContents.description]
              }}
            />
          </div>
        </GiftCardSection>
      </>
    )
  }
  return (
    <Fragment>
      {giftcardLoaded && (
        <StepWrapper>
          {!isBonus ?
            <>
              <TicketWrapped isCheckoutStep={!isBonus} />
              {LayoutRender()}
            </>
            :
            <TicketWrapped isCheckoutStep={!isBonus} >
              {LayoutRender()}
            </TicketWrapped>
          }
        </StepWrapper>
      )}

      <Modal
        title={"Error"}
        isOpen={isModalError}
        close={hideModalError}
      >
        <p>{"Already Used"}</p>
      </Modal>
      <Modal
        title={t("purchase.email_confirmation.header")}
        isOpen={isModal}
        close={hideModal}
      >
        <EmailConfirmation data={isGiftCardApplied ? payloadForDirect : []} isPayble={isPayble} />
      </Modal>
      <Modal
        title={t("purchase.attention")}
        isOpen={isAttentionModal}
        close={hideAttentionModal}
      >
        <BonusCardAttention>
          <div className="attention-bonuscard__content">
            <h2>{t("purchase.bonus_attention_modal_content")}</h2>
            <h3>{t("purchase.bonus_attention_modal_subcontent")}</h3>
          </div>
          <Button
            className="attention-bonuscard__btn"
            isPrimary
            onClick={hideAttentionModal}
          >
            {t("common.ok")}
          </Button>
        </BonusCardAttention>
      </Modal>
      <Modal
        isOpen={errorConfirm}
        close={hideErrorConfirm}
        title={t("common.error_title")}
      >
        <List>
          <li>{validationError?.replaceAll(";", ", ")}</li>
        </List>
      </Modal>
    </Fragment>
  );
};

StepCheckout.defaultProps = defaultProps;
StepCheckout.propTypes = propTypes;
export default StepCheckout;
